import { gql } from '@apollo/client'

export const TASK_CATEGORIES_QUERY = gql`
  query taskCategories {
    taskCategories {
      collection {
        id
        name
        color
        textColor
        createdAt
        updatedAt
      }
    }
  }
`
